// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* займає повну висоту вікна */
}`, "",{"version":3,"sources":["webpack://./src/pages/spin/style/spin.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,8BAA8B;AAC/C","sourcesContent":[".spinner-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh; /* займає повну висоту вікна */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
